export function retryVideoWithMp4(
  video: HTMLVideoElement,
  attempted: { current: boolean },
): boolean {
  if (attempted.current || !video.currentSrc) return false;

  let sourceUrl: URL;
  try {
    sourceUrl = new URL(video.currentSrc);
  } catch {
    return false;
  }

  if (!sourceUrl.pathname.toLowerCase().endsWith(".webm")) return false;

  // 2026-10-04 browser repro: Chromium reported `canPlayType() === "probably"`
  // but failed to decode this VP9 source (MediaError code 3). Retry the same
  // rendition as H.264 MP4. See https://developer.mozilla.org/en-US/docs/Web/API/MediaError.
  sourceUrl.pathname = `${sourceUrl.pathname.slice(0, -".webm".length)}.mp4`;
  attempted.current = true;
  video.src = sourceUrl.href;
  video.load();
  return true;
}
